import React from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const PTListV2 = (props) => {
  const token = window.localStorage.getItem('auth-token')
  const { operator: { id } } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!id) {
    return (
      <div className='index pts'>
        <p>waiting for operator...</p>
      </div>
    )
  }

  // Must leave empty h1 there for element below not to be cropped...
  return (
    <div className='index pts'>
      {/* eslint-disable-next-line */}
      <h1 />
      <cl-pt
        mountpath={`/operators/${id}/pts`}
        apiurl={`https://pt-api.${env()}.credlock.net/api`}
        token={token}
      />
    </div>
  )
}

export default PTListV2
